<template>
    <div v-if="groups.length && groups.length > 1" class="card mb-3">
        <div class="card-header">
            <h6 class="card-subtitle">
                <font-awesome-icon icon="users" class="mr-2" />
                My Groups
            </h6>
            <span class="text-muted">Select group.</span>
        </div>
        <div class="card-body card-scroll text-center">
            <a
                v-for="(group, idx) in groups"
                v-bind:key="idx"
                class="btn btn-primary col-sm-2 m-2"
                :href="`${group.group_base_url}?token=${token}`"
                target="_blank"
            >
                <!-- <i v-if="student.has_account" class="fas fa-address-card"></i> -->
                {{ group.group_name }}
            </a>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";

export default {
    data() {
        return {
            groups: []
        };
    },
    mounted() {
        this.loadGroups();
    },
    methods: {
        loadGroups() {
            this.$api.get("/api/group/list").then((response) => {
                this.groups = response.data.groups.filter(group => group.enabled);
            }).catch((error) => {
                console.error("Error loading groups:", error);
            });
        }
    },
    computed: mapState(["token"])
}
</script>